import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";

const Section = styled.section`
  padding: 96px 0 48px;
  background: var(--nd-black);
  position: relative;
  overflow: hidden;
  &::before {
    content: "";
    position: absolute; inset: 0;
    background-image: radial-gradient(circle, var(--nd-border) 0.5px, transparent 0.5px);
    background-size: 12px 12px;
    opacity: 0.3;
    pointer-events: none;
  }
  @media (max-width: 768px) { padding: 64px 0 32px; }
`;

const Inner = styled.div`
  position: relative;
  max-width: 880px;
`;

const Kicker = styled.p`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-secondary);
  margin: 0 0 16px;
`;

const Title = styled.h1`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 48px;
  font-weight: 500;
  color: var(--nd-text-display);
  line-height: 1.05;
  letter-spacing: -0.02em;
  margin: 0 0 12px;
  @media (max-width: 768px) { font-size: 32px; }
`;

const ClientHint = styled.p`
  font-family: 'Space Mono', monospace;
  font-size: 13px;
  letter-spacing: 0.04em;
  color: var(--nd-text-secondary);
  margin: 0 0 24px;
`;

const Description = styled.p`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 18px;
  color: var(--nd-text-secondary);
  line-height: 1.5;
  margin: 0;
  max-width: 720px;
`;

const ProjectHero = ({ opening }) => (
  <Section>
    <Container>
      <Inner>
        <Kicker>{opening.kicker}</Kicker>
        <Title>{opening.title}</Title>
        <ClientHint>For {opening.clientHint}</ClientHint>
        <Description>{opening.description}</Description>
      </Inner>
    </Container>
  </Section>
);

export default ProjectHero;
